import {DestinationType} from 'graphql-client/__generated/graphqlGlobalTypes';
import ExtractByTypename from 'graphql-client/ExtractByTypename';

import {ListEventSubscriptions} from './__generated/ListEventSubscriptions';

type EventSubscription = ListEventSubscriptions['eventSubscriptionsListing']['eventSubscriptions'][number];

type AppEventSubscription = ExtractByTypename<EventSubscription, 'AppEventSubscriptionNode'>;

type EventBridgeEventSubscription = ExtractByTypename<EventSubscription, 'EventbridgeEventSubscriptionNode'>;

export const DESTINATION_TYPE_TO_DISPLAY_TEXT: {[key in DestinationType]: string} = {
  [DestinationType.EVENTBRIDGE]: 'AWS EventBridge',
  [DestinationType.WEBHOOK]: 'Webhook',
  // all app subscriptions are displayed as webhook, the only currently support delivery method
  [DestinationType.APP]: 'Webhook URL',
};

export function isEventBridgeSubscription(
  eventSubscription: EventSubscription
): eventSubscription is EventBridgeEventSubscription {
  return eventSubscription.__typename === 'EventbridgeEventSubscriptionNode';
}

export function isAppSubscription(
  eventSubscription: EventSubscription
): eventSubscription is AppEventSubscription {
  return eventSubscription.__typename === 'AppEventSubscriptionNode';
}
